var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"is-edit-name":false,"resource":"federatedclusterrolebindings"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }